import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../../../../../app.settings';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  topicKeywordUrl = `${AppSettings.API_ENDPOINT}/${'topic-keywords/1'}`;
  saveTopicUrl = `${AppSettings.API_ENDPOINT}/${'save-topic/0'}`;
  updateTopicUrl = `${AppSettings.API_ENDPOINT}/${'save-topic'}`;
  deleteTopicUrl = `${AppSettings.API_ENDPOINT}/${'delete-keywords'}`;
  surveyUrl = `${AppSettings.API_ENDPOINT}/${'get-survey-config'}`;
  stopWordUrl = `${AppSettings.API_ENDPOINT}/${'get-stopwords'}`;
  emailConfigUrl = `${AppSettings.API_ENDPOINT}/${'email-config'}`;
  updateEmailConfigUrl = `${AppSettings.API_ENDPOINT}/${'email-config-update'}`;
  updateStopWordUrl = `${AppSettings.API_ENDPOINT}/${'update-stopwords'}`;
  topicConfigUrl = `${AppSettings.API_ENDPOINT}/${'get-keywords'}`;

  constructor(private http: HttpClient) { }

  getTopicKeyword(){
    return this.http.get(this.topicKeywordUrl);
  }

  getTopicConfigById(configId:any){
    return this.http.get(this.topicConfigUrl+"/"+configId);
  }

  saveTopics(data:any){
    return this.http.post(this.saveTopicUrl, data);
  }

  updateTopic(id:string, data:any){
    return this.http.post(`${this.updateTopicUrl}/${id}`,data);
  }

  deleteTopicData(id:string){
    return this.http.get(`${this.deleteTopicUrl}/${id}`);
  }

  getSurvey(){
    return this.http.get(this.surveyUrl);
  }

  getStopWord(word:string){
    return this.http.get(`${this.stopWordUrl}/${word}`);
  }

  getEmailConfiguration(){
    return this.http.get(this.emailConfigUrl);
  }

  updateEmailConfiguration(data:any){
    return this.http.post(this.updateEmailConfigUrl, data);
  }

  updateStopWord(data:any){
    return this.http.post(this.updateStopWordUrl, data);
  }

}
